module.exports = __webpack_public_path__ + "img/viewmore.32e650d0.svg";